import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from '../components/Auth/Login';
import ProtectedRoute from '../components/Auth/ProtectedRoute';
import Dashboard from '../components/Dashboard/Dashboard';
import Users from '../components/Users/Users';
import UserDetails from '../components/Users/UserDetails';
import ChatAI from '../components/ChatAI/ChatAI';
import Report from '../components/Report/Report';
import Subscription from '../components/Subscription/Subscription';
import CompatibilityAI from '../components/CompatibilityAI/CompatibilityAI';
import Prediction from '../components/Prediction/Prediction';
import Transactions from '../components/Transactions/Transactions';
import Notifications from '../components/Notifications/Notifications';
import Layout from '../components/Layout/Layout';

const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        {/* Redirect root path to login */}
        <Route path="/" element={<Navigate to="/login" replace />} />

        {/* Login route (without layout) */}
        <Route path="/login" element={<Login />} />

        {/* Protected routes with layout */}
        <Route path="/" element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }>
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="users" element={<Users />} />
          <Route path="users/:userId" element={<UserDetails />} />
          <Route path="chat-ai" element={<ChatAI />} />
          <Route path="report" element={<Report />} />
          <Route path="subscriptions" element={<Subscription />} />
          <Route path="compatibility-ai" element={<CompatibilityAI />} />
          <Route path="prediction" element={<Prediction />} />
          <Route path="transactions" element={<Transactions />} />
          <Route path="notifications" element={<Notifications />} />
          {/* You can add more protected routes here */}
          {/* Example:
          <Route path="products" element={<Products />} />
          <Route path="analytics" element={<Analytics />} />
          <Route path="profile" element={<Profile />} />
          <Route path="settings" element={<Settings />} />
          */}
        </Route>

        {/* Catch-all route for 404 */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
};

export default AppRoutes;